<template>
	<div>
		<basic-container>
			<el-card v-loading="isTableLoading" style="margin-top: 10px">
				<avue-form ref="form_ts" v-model="formData" :option="optionData" :upload-error="handleUploadError">
					<template slot="crmListStr" slot-scope="{size}">
						<div v-html="formData.crmListStr"></div>
					</template>
					<template slot="label" slot-scope="{size}">
						<div v-if="riskList && riskList.length > 0">
							<MbLabel
								v-for="(item, index) in riskList"
								:key="index"
								:category="item.category"
								:weight="item.STRONG"
								:isDept="item.deptId != 0"
								:labelName="item.name"
								:icon="item.icon || ''"></MbLabel>
						</div>
					</template>
					<template slot="settlePerson" slot-scope="{size}">
						<div
							v-if="formData.settleType && settleInfoList.length > 0"
							class="divide"
							style="margin-bottom: 15px"></div>
						<avue-form
							v-for="(item, index) in settleInfoList"
							:key="index"
							ref="form_ts_person"
							v-model="settleInfoList[index]"
							:option="settleInfoOption">
							<template slot="menuForm" style="height: 0 !important"></template>
							<template slot="del">
								<el-button v-if="!isSettleAgent" icon="el-icon-minus" type="info" @click="onDel(index)">删除</el-button>
							</template>
						</avue-form>

						<el-button
							v-if="!isSettleAgent && !isView"
							:disabled="!isSettlePrivate && settleInfoList.length > 0"
							:size="size"
							icon="el-icon-plus"
							style="margin-left: 110px; margin-bottom: 15px"
							type="primary"
							@click="initSettleData">
							{{ isSettlePrivate ? '新增结算人' : '新增结算企业' }}
						</el-button>
						<div v-if="formData.settleType && settleInfoList.length > 0" class="divide"></div>
					</template>
				</avue-form>

				<el-row justify="center" style="padding: 10px" type="flex">
					<el-button v-if="isView" :loading="isSubLoading" type="primary" plain @click="onDisableEdit(false)">
						编辑
					</el-button>
					<el-button v-else :loading="isSubLoading" type="primary" @click="onCommitHint">提交</el-button>
					<!-- <el-button type="primary" @click="onCopyData">复制</el-button> -->
				</el-row>
			</el-card>

			<el-dialog title="特殊客户来源数据选择" :visible.sync="searchCrmCustomerFlag" width="60%">
				<originChannelIdList :channel="formData" @chooseChannelId="chooseChannelId"></originChannelIdList>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="searchCrmCustomerFlag = false">关 闭</el-button>
				</div>
			</el-dialog>

			<el-dialog title="客户线索选择" :visible.sync="chooseClueFlag" width="80%">
				<clueIdList :channel="formData" @chooseClue="chooseClue"></clueIdList>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="chooseClueFlag = false">关 闭</el-button>
				</div>
			</el-dialog>
		</basic-container>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// import { mapGetters } from 'vuex'

import {getAreaList} from '@/api/insurance/policy'
import {getSettlementRuleAwardList, getSettlementRuleBasicList} from '@/api/insurance/settlement'
import {
	editFollowSort,
	getCustomerList,
	getFirstHuokeTime,
	getInvisibleObj,
	getObj,
	getPutObj,
	getRiskTag,
	searchCrmCustomer,
	searchCustomerClue,
	searchWeworkGroup,
} from '@/api/team/place'
import {listAddOption, settleTaxRateDicList} from '@/const/crud/channel/channelOption'
import {SettlePeriod, SettleRemitAccount, SettleType} from '@/const/enum'
import {mixinsSettleInfo} from '@/mixins/mixinsSettleInfo'
import {isSettlePrivate as isSettlePrivateFn, isSettleTypeSame, onGetSettleType} from '@/util/settleUtils'
import {getStore} from '@/util/store'
import {rule} from '@/util/validateRules'
import MbLabel from '@mb/mb-label'
import clueIdList from './clueIdList.vue'
import originChannelIdList from './originChannelIdList.vue'
import {decryptMessageByArray, decryptMessageByObject} from '@/util/secret'
export default {
	name: 'listAdd',
	mixins: [mixinsSettleInfo],
	components: {
		originChannelIdList,
		clueIdList,
		MbLabel,
	},
	props: {},
	data() {
		return {
			isView: false,
			riskList: [],
			initClueFlag: false,
			chooseClueFlag: false,
			initCustomerSourceChannelFieldFlag: false,
			searchCrmCustomerFlag: false,
			currentStep: 0,
			channelId: 0,
			isSubLoading: false,
			initCrmFlag: false,
			isTableLoading: true,
			//结算信息
			settleInfoList: [],
			formData: {
				settleType: '',
				settlePeriod: '',
				settleAccounts: [],
				insureTypes: [],
				businessAreas: '',
				channelAttr: '',
				ruleAwardIds: [],
				ruleBasicId: '',
			},
			optionDataCopy: {},
			//记录进入的微信号
			lastWechatId: '',
			optionData: this.deepClone(listAddOption),
			settleInfoOption: {},
			//判断产品首次是不是为空
			isFirstInsureTypesNull: false,
			//不可见
			insureTypesInvisible: [],
			//可见
			insureTypesVisible: [],
			//备份结算信息
			settleAccountsCopy: [],
			//临时保存结算信息
			settleAccountsSave: {
				[SettleType.PRIVATE]: [],
				[SettleType.PUBLIC]: [],
				[SettleType.AGENT]: [],
			},
			//备份
			weworkGroupData: {},
		}
	},
	async created() {
		//判断是新增，修改，查看
		let {type = '', channelId} = this.$route.query
		this.isView = type === 'view'
		//获取地区
		let {
			data: {data = [], code = -1},
		} = (await getAreaList(2)) || {}
		if (this.validatenull(data) || code !== 0) {
			return
		}
		this.optionData.column.forEach((itemData) => {
			let {prop} = itemData
			if (prop === 'cityCode') {
				itemData.dicData = data
			} else if (prop === 'businessAreas') {
				let tempData = data.map((dataItem) => {
					let {areaName, areaCode} = dataItem
					return {areaName, areaCode, disabled: false}
				})
				tempData.unshift({
					areaName: '全国地区',
					areaCode: '000000',
					disabled: false,
				})
				itemData.dicData = tempData
			}
		})

		//获取不可见的产品
		await this.getInvisibleProduct()
		//处理奖励结算默认数据
		await this.onDealRewardSettlement()
		switch (type) {
			case 'add':
				sessionStorage.removeItem('validHasBeenPresence_edit')
				editFollowSort()
				this.initAddAll()
				//禁止代理人佣金
				this.onHandleAgentSettle()
				break
			case 'edit':
			case 'view':
				//编辑
				this.channelId = channelId
				sessionStorage.setItem('validHasBeenPresence_edit', JSON.stringify({type: '2', value: channelId}))
				//编辑要吧状态选项去掉
				this.optionData.column.forEach((itemData) => {
					if (itemData.prop === 'status') {
						itemData.display = false
					}
				})
				await this.getChannelDataById()
				break
		}

		//给微信号加失去焦点处理事件
		let tempWechatId = this.findObject(this.optionData.column, 'wechatId')
		tempWechatId.blur = this.onWechatBlur
		//获取风险标签
		await this.getRiskTag()
		this.isTableLoading = false
		//控制显隐
		if (this.isView) {
			this.$nextTick(() => {
				this.onDisableEdit(true)
			})
		}
	},
	computed: {
		isAddType() {
			let {type} = this.$route.query
			return type === 'add'
		},
		setTitle() {
			return this.isAddType ? '新增渠道' : '编辑渠道'
		},
		getInsureTypesData() {
			let tempInsureTypes = getStore({name: 'insureTypes'})
			return tempInsureTypes.map(({type}) => type)
		},
	},
	watch: {
		'formData.status': {
			handler(newVal, oldVal) {
				//判断状态是否可用，如果不可用，则隐藏停用状态
				this.optionData.column.forEach((itemData) => {
					if (itemData.prop === 'insureAuthority' || itemData.prop === 'insureTypes') {
						itemData.display = newVal === 1
					}
				})
			},
			immediate: true,
		},

		'formData.accountType': {
			handler(newVal, oldVal) {
				if (newVal == 1) {
					//判断状态是否可用，如果不可用，则隐藏停用状态
					this.optionData = this.optionDataCopy
				} else {
					this.optionDataCopy = this.deepClone(this.optionData)
					//判断状态是否可用，如果不可用，则隐藏停用状态
					this.optionData.column.forEach((itemData) => {
						if (
							!(
								itemData.prop == 'loginMobile' ||
								itemData.prop == 'accountType' ||
								itemData.prop == 'name' ||
								itemData.prop == 'contactPerson' ||
								itemData.prop == 'contactId' ||
								itemData.prop == 'contactPersonMobile'
							)
						) {
							itemData.display = false
						}
					})
				}
				//如果之前是体验账号切换到正式账号需要把结算数据 带入填充
				if (oldVal == 2 && newVal == 1) {
					this.initAddAll()
					this.onDealRewardSettlement(2)
				}
			},
			immediate: true,
		},
		// "formData.businessAreas": {
		//   handler (newVal, oldVal) {
		//     //如果选了全国，则其他地区禁止选
		//     if (!this.validatenull(newVal)) {
		//       if (!this.validatenull(oldVal) && oldVal.indexOf("000000") !== -1) {
		//         this.formData.businessAreas = newVal.replace("000000,", "");
		//       } else if (newVal !== "000000" && newVal.indexOf("000000") !== -1) {
		//         this.formData.businessAreas = "000000";
		//       }
		//     }
		//   },
		//   immediate: true,
		// },
		'formData.settleType': {
			async handler(newVal, oldVAl = '') {
				//判断结算方式
				if (!this.validatenull(newVal)) {
					//处理结算信息option
					this.onSetSettleInfoOption(newVal, false)

					if (oldVAl !== '') {
						//临时保存结算信息
						//如果是对私，则分别存储，如果是对公，则统一
						this.settleAccountsSave[this.isSettlePrivate ? oldVAl : onGetSettleType(oldVAl)] = this.deepClone(
							this.settleInfoList,
						)
					}

					//处理settleTaxRate 的dicData
					let tempSettleTaxRate = this.findObject(this.optionData.column, 'settleTaxRate')
					if (tempSettleTaxRate) {
						tempSettleTaxRate.dicData = settleTaxRateDicList[newVal]
					}
					//设置结算数据
					this.setSettleAccountData(newVal)
					//框架内的control 不好用，改为直接控制
					//PUBLIC 服务对公，INTER 中介对公，PRIVATE 第三方清分，AGENT 代理人佣金
					let display = newVal === SettleType.PUBLIC || newVal === SettleType.INTER
					console.log('vthis.formData.accountType', this.formData)
					//如果为服务对公和中介对公，则周期为月结, 周期不可点击
					let settlePeriod = newVal === SettleType.PUBLIC || newVal === SettleType.INTER
					//如果中介对公和代理人佣金，则为 美保经纪
					let settleRemitAccount = newVal === SettleType.INTER || newVal === SettleType.AGENT
					//如果为服务对公和第三方清分，则清空， 中介对公则为 600， 代理人对公，为 500，
					let settleTaxRate = newVal === SettleType.PUBLIC || newVal === SettleType.PRIVATE
					//如果是新增，并且oldVal存在，才处理
					if (this.isAddType || oldVAl) {
						this.formData.settleRemitAccount = settleRemitAccount ? SettleRemitAccount.MBJJ : ''
						//settlePeriod true,则改变值
						if (settlePeriod) {
							this.formData.settlePeriod = SettlePeriod.MONTH
						}
						this.formData.settleTaxRate = settleTaxRate ? '' : newVal === SettleType.INTER ? 600 : 500
					}
					this.onDealItem([
						{
							prop: 'settleTaxFlag',
							display,
						},
						//settleTaxRate settleRemitAccount
						{
							prop: 'settleTaxRate',
							display: newVal !== SettleType.PRIVATE,
							disabled: newVal !== SettleType.PUBLIC,
						},
						{
							//结算打款账户 第三方清分 不展示
							prop: 'settleRemitAccount',
							display: newVal !== SettleType.PRIVATE,
							disabled: settleRemitAccount,
						},
						{
							prop: 'contractStartTime',
							display,
						},
						{
							prop: 'contractEndTime',
							display,
						},
						{
							prop: 'settleProtocols',
							display,
						},
						{
							prop: 'settlePeriod',
							disabled: settlePeriod,
						},
					])

					this.autoSettleChangeRules()
				}
			},
			immediate: true,
		},
		'formData.serviceType': {
			handler(newVal = '', oldVal) {
				if (newVal) {
					this.onDealItem([
						{
							prop: 'serviceTypeRemark',
							display: newVal === '100',
						},
						{
							prop: 'serviceType',
							span: newVal === '100' ? 12 : 24,
						},
					])
				}
			},
			immediate: true,
		},
		'formData.claimsWay': {
			handler(newVal = '', oldVal) {
				if (newVal) {
					this.onDealItem([
						{
							prop: 'claimsContactMobile',
							rules: [
								{
									required: true,
									message: '请输入理赔联系人电话',
								},
								{
									min: 11,
									max: 11,
									message: '请输入正确的手机号码',
									trigger: 'blur',
								},
								{
									validator: rule.validatorMobile,
									trigger: 'blur',
								},
							],
						},
						{
							prop: 'claimsContactIdentity',
							rules: [
								{
									required: true,
									message: '请选择理赔联系人身份',
								},
							],
						},
						{
							prop: 'claimsContactName',
							rules: [
								{
									required: true,
									message: '请输入理赔联系人称呼',
								},
							],
						},
					])
				} else {
					this.onDealItem([
						{
							prop: 'claimsContactMobile',
							rules: [
								{
									min: 11,
									max: 11,
									message: '请输入正确的手机号码',
									trigger: 'blur',
								},
								{
									validator: rule.validatorMobile,
									trigger: 'blur',
								},
							],
						},
						{
							prop: 'claimsContactIdentity',
							rules: [],
						},
						{
							prop: 'claimsContactName',
							rules: [],
						},
					])
				}
			},
			immediate: true,
		},

		'formData.channelAttr': {
			handler(newVal = '', oldVal) {
				if (newVal) {
					let labelTemp = '备注渠道属性'
					switch (newVal) {
						case '1':
							labelTemp = '备注代理公司名称'
							break
						case '12':
							labelTemp = '备注保险平台'
							break
						case '2':
						case '14':
							labelTemp = '备注保司名称'
							break
						case '3':
						case '16':
						case '17':
							labelTemp = '备注公司名称'
							break
						case '100':
							labelTemp = '备注其他渠道属性'
							break
					}
					this.onDealItem([
						{
							prop: 'channelAttrRemark',
							label: labelTemp,
						},
						{
							prop: 'serviceType',
							display: newVal === '17',
						},
						{
							prop: 'serviceTypeRemark',
							display: newVal === '17',
						},
					])
				}
			},
			immediate: true,
		},
		'formData.industryResource': {
			handler(newVal = '', oldVal) {
				if (newVal) {
					this.onDealItem([
						{
							prop: 'industryResourceRemark',
							display: newVal === '100',
						},
						{
							prop: 'industryResource',
							span: newVal === '100' ? 12 : 24,
						},
					])
				}
			},
			immediate: true,
		},
		// 'formData.channelFromTool': {
		//   handler (newVal = '', oldVal) {
		//     if (newVal) {
		//       this.onDealItem([{
		//         prop: 'channelFromToolRemark',
		//         display: newVal === '99',
		//       }, {
		//         prop: 'channelFromTool',
		//         span: newVal === "99" ? 12 : 24,
		//       }])
		//     }
		//   },
		//   immediate: true,
		// },
		//客户来源方式
		'formData.customerSourceType': {
			handler(newVal = '', oldVal) {
				console.log('customerSourceType', newVal, '----', oldVal, this.initClueFlag)
				//如果是手动选择则展示 如果是留资线索就直接选择
				this.onDealItem([
					{
						prop: 'customerSource',
						display: newVal == 'HAND',
					},
					{
						prop: 'customerSourceType',
						row: newVal != 'CLUE',
					},
					{
						prop: 'clueLabel',
						display: newVal == 'CLUE',
					},

					{
						prop: 'customerSourceChannelField',
						display: newVal == 'HAND',
					},
				])
				if (this.chooseClueFlag) {
					return
				}

				if ((newVal && newVal == oldVal) || (!this.initClueFlag && !this.isAddType)) {
					return
				}

				//如果是留资线索就选择
				if (newVal != 'CLUE') {
					this.formData.clueLabel = ''
				}
				//如果是留资线索就选择
				if (newVal == 'CLUE') {
					setTimeout(() => {
						this.formData.customerSourceType = ''
					}, 20)
					this.formData.customerSource = ''
					this.formData.customerSourceChannelType = ''
					this.formData.customerSourceChannelId = ''
					this.formData.customerSourceChannelField = ''
					this.chooseClueFlag = true
				}
			},
			immediate: true,
		},

		//客户来源方式
		'formData.settleMethod': {
			handler(newVal = '', oldVal) {
				if (newVal == 'DUAL') {
					this.formData.settleType = SettleType.PRIVATE
				}
				setTimeout(() => {
					//如果是手动选择则展示 如果是留资线索就直接选择
					this.onDealItem([
						{
							prop: 'ruleBasicId',
							display: newVal == 'NORMAL',
						},
						{
							prop: 'ruleAwardIds',
							display: newVal == 'NORMAL',
						},
						{
							prop: 'autoSettle',
							display: newVal == 'NORMAL',
						},
						{
							prop: 'settleType',
							display: newVal == 'NORMAL',
						},
						{
							prop: 'settlePeriod',
							display: newVal == 'NORMAL',
						},
						{
							prop: 'settlePerson',
							display: newVal == 'NORMAL',
						},
					])
				}, 1)
			},
			immediate: true,
		},
		//结算开关
		'formData.autoSettle': {
			handler(newVal = '', oldVal = '') {
				//如果开启自动结算，又没有结算信息，则自动添加
				if (!this.isTableLoading && newVal == '1' && this.settleInfoList.length == 0) {
					this.initSettleData()
				}
			},
		},
		//客户来源
		'formData.customerSource': {
			handler(newVal = '', oldVal) {
				console.log('customerSource-----', newVal)
				if ((newVal && newVal == oldVal) || this.formData.customerSourceType != 'HAND') {
					return
				}
				//如果选择了客户来源 则 反现二级客户来源渠道类型
				if (newVal) {
					//1.先找出选择的客户来源的对象
					let customerSourceDic = this.$refs.form_ts.DIC.customerSource
					if (customerSourceDic && customerSourceDic.length > 0) {
						let obj = customerSourceDic[customerSourceDic.findIndex((o) => o.originSource == newVal)]
						if (obj) {
							//设置客户来源的 dicData
							this.findObject(this.optionData.column, 'customerSourceChannelField').dicData =
								obj.crmCustomerSourceChannelList
									? obj.crmCustomerSourceChannelList.map((item) => ({
											...item,
											customerSourceChannelField: `${item.orginChannelType || ''}${item.originChannelId || ''}`,
									  }))
									: []
							//如果是第一次加载并且是修改 则不制空 否则滞空
							if (!this.isAddType && !this.initCrmFlag) {
								this.initCrmFlag = true
							} else {
								this.formData.customerSourceChannelType = ''
								this.formData.customerSourceChannelId = ''
								this.formData.customerSourceChannelField = ''
							}
						}
					}
				} else {
					//初始化客户来源的渠道类型相关数据
					this.findObject(this.optionData.column, 'customerSourceChannelField').dicData = []
					this.formData.customerSourceChannelType = ''
					this.formData.customerSourceChannelId = ''
					this.formData.customerSourceChannelField = ''
				}
			},
			immediate: true,
		},
		//客户来源渠道类型
		'formData.customerSourceChannelField': {
			handler(newVal = '', oldVal) {
				if ((newVal && newVal == oldVal) || this.formData.customerSourceType != 'HAND') {
					return
				}
				let dicData = this.findObject(this.optionData.column, 'customerSourceChannelField').dicData
				//如果选择了客户来源渠道类型 则判断 orginChannelType == customer  如果为 customer 则必须要选择originChannelId
				if (newVal) {
					let customerSourceChanne = dicData[dicData.findIndex((item) => item.customerSourceChannelField == newVal)]
					//如果需要二次选择则必须要选择originChannelId
					if (newVal.includes('customer')) {
						if (!customerSourceChanne.originChanelLabel.includes('-')) {
							setTimeout(() => {
								this.formData.customerSourceChannelField = ''
							}, 20)
							this.$message.warning(`请选择${customerSourceChanne.originChanelLabel}数据!`)
							this.searchCrmCustomerFlag = true
						}
					} else {
						let dicData = this.findObject(this.optionData.column, 'customerSourceChannelField').dicData
						this.findObject(this.optionData.column, 'customerSourceChannelField').dicData = dicData.map((item) =>
							item.orginChannelType != 'customer'
								? item
								: {
										...item,
										originChanelLabel: item.originChanelLabel.split('-')[0],
								  },
						)

						let {orginChannelType = '', originChannelId = ''} = customerSourceChanne
						this.formData.customerSourceChannelType = orginChannelType
						this.formData.customerSourceChannelId = originChannelId
					}
				} else {
					this.findObject(this.optionData.column, 'customerSourceChannelField').dicData = dicData.map((item) =>
						item.orginChannelType != 'customer'
							? item
							: {
									...item,
									originChanelLabel: item.originChanelLabel.split('-')[0],
							  },
					)
					if (!this.initCustomerSourceChannelFieldFlag && !this.isAddType) {
						return
					}

					this.formData.customerSourceChannelType = ''
					this.formData.customerSourceChannelId = ''
					this.formData.customerSourceChannelField = ''
				}
			},
		},
		// 'formData.channelFromWay': {
		//   handler (newVal = '', oldVal) {
		//     if (newVal) {
		//       let label = "";
		//       if (newVal === "7") {
		//         label = "代理转介绍人姓名";
		//       } else if (newVal === "99") {
		//         label = "其他来源方式";
		//       }
		//       this.onDealItem([{
		//         prop: 'channelFromWayRemark',
		//         label: label,
		//         display: label,
		//       }, {
		//         prop: 'channelFromWay',
		//         span: label ? 12 : 24,
		//       }, {
		//         prop: 'cusId',
		//         display: newVal === '36',
		//       }, {
		//         prop: 'cusWay',
		//         display: newVal === '36',
		//       },
		//       ])
		//     }
		//   },
		//   immediate: true,
		// },
		// 'formData.channelFrom': {
		//   handler (newVal = '', oldVal) {
		//     if (newVal) {
		//       this.onDealItem([{
		//         prop: 'channelFromIntro',
		//         display: newVal === '2',
		//       }, {
		//         prop: 'channelFromIntroId',
		//         display: newVal === '2',
		//       }])
		//     }
		//   },
		//   immediate: true,
		// },
		'formData.weworkGroupId': {
			handler(newVal, oldVal) {
				// 清空业务跟进人
				// this.formData.followId = ''
				// 更新业务跟进人dicUrl
				this.findObject(this.optionData.column, 'weworkGroupId').dicData = []
				const followIdOption = this.findObject(this.optionData.column, 'followId')
				if (followIdOption) {
					if (newVal && newVal.length > 0) {
						// 处理可能的数组或字符串格式
						let weworkGroupIds = newVal
						if (Array.isArray(newVal)) {
							weworkGroupIds = newVal.join(',')
						}
						followIdOption.dicUrl = `/dist/distChannel/follow/listContact?weworkGroupIds=${weworkGroupIds}`
					} else {
						// 恢复默认接口
						followIdOption.dicUrl = '/dist/distChannel/follow/listContact'
					}

					// 如果表单已经渲染，刷新字典数据
					if (this.$refs.form_ts) {
						this.$refs.form_ts.updateDic('followId')
					}
				}
				setTimeout(() => {
					console.log('this.$refs.form_ts.DIC', this.$refs.form_ts)
					this.$forceUpdate()
				}, 200)
			},
		},
	},
	methods: {
		async getRiskTag() {
			let {data} = await getRiskTag({
				sceneKey: 'distChannel',
				object: 'CHAN',
				userId: '0',
				objectId: this.channelId,
			})
			if (data.code == 0 && data.data) {
				this.riskList = data.data
			}
		},
		initAddAll() {
			console.log(333, 'initAddaLL')
			//新增 如果不存在 则默认为对私支付
			if (!this.formData.settleType) {
				this.formData.settleType = SettleType.PRIVATE
			}
			this.initSettleData()
			//业务跟进人添加默认值
			setTimeout(() => {
				console.log('this.$refs.form_ts.DIC.followId', this.$refs.form_ts.DIC.followId)
				if (this.$refs.form_ts.DIC.followId && this.$refs.form_ts.DIC.followId.length > 0) {
					this.formData.followId = this.$refs.form_ts.DIC.followId[0].id
				}
			}, 1200)
			//处理产品
			this.onDealInsureTypes()
			//新增隐藏创建时间
			this.findObject(this.optionData.column, 'createdAt').display = false
		},
		autoSettleChangeRules() {
			// 如果自动结算 关闭的话 则结算信息都是非必填
			// if (this.settleInfoOption.column) {
			// 	this.settleInfoOption.column.forEach((o) => {
			// 		if (o.rules) {
			// 			this.findObject(this.settleInfoOption.column, o.prop).rules[0].required = this.formData.autoSettle === 1
			// 		}
			// 	})
			// }
		},
		//选择 crm 客户来源字段
		chooseChannelId(row) {
			console.log('chooseChannelId', row)
			let dicData = this.findObject(this.optionData.column, 'customerSourceChannelField').dicData

			let {cusName = '', nickName = '', wechatNos = [], mainFollowIdName} = row
			let label = `${cusName || '空'}-${nickName || '空'}-${
				wechatNos && wechatNos.length > 0 ? wechatNos.join('、') : '空'
			}-客户经理：${mainFollowIdName || '空'}`

			this.findObject(this.optionData.column, 'customerSourceChannelField').dicData = dicData.map((item) =>
				item.orginChannelType != 'customer'
					? item
					: {
							...item,
							originChanelLabel: `${item.originChanelLabel}-${label}`,
					  },
			)
			//初始化客户来源的渠道类型相关数据
			this.formData.customerSourceChannelId = row.cusId
			this.formData.customerSourceChannelField = 'customer'
			this.formData.customerSourceChannelType = 'customer'
			this.searchCrmCustomerFlag = false
		},
		// 选择留资客户
		chooseClue(row) {
			console.log('chooseChannelId', row)
			let dicData = this.findObject(this.optionData.column, 'customerSourceType').dicData

			let {
				nickName = '',
				mobile = '',
				id = '',
				sourceIdLast = '',
				sourceIdText = '',
				customerSourceIdText = '',
				customerSourceChannelIdText = '',
			} = row
			let label = `客户线索：${mobile || '空'}   线索首次客户来源：${customerSourceIdText || '空'}-${
				customerSourceChannelIdText || '空'
			}-${sourceIdText || '空'}`
			this.formData.clueLabel = label

			this.formData.customerSource = id
			this.formData.customerSourceType = 'CLUE'
			this.formData.customerSourceChannelId = ''
			this.formData.customerSourceChannelField = ''
			this.formData.customerSourceChannelType = ''
			setTimeout(() => {
				this.chooseClueFlag = false
			}, 20)
		},
		//获取不自动勾选的产品
		async getInvisibleProduct() {
			let response = await getInvisibleObj().catch(() => {})
			if (this.validatenull(response) || this.validatenull(response.data)) {
				this.$message.error('请求数据有误!')
				return
			}
			//不可见的
			this.insureTypesInvisible = response.data.data || []
			//获取可见的
			let tempInsureTypes = this.getInsureTypesData
			console.log('getInvisibleProduct-----', tempInsureTypes)
			if (this.insureTypesInvisible.length > 0) {
				tempInsureTypes = tempInsureTypes.filter((itemData) => {
					return !this.insureTypesInvisible.includes(itemData)
				})
			}
			this.insureTypesVisible = tempInsureTypes
		},
		//根据渠道ID 获取渠道信息
		async getChannelDataById() {
			this.isTableLoading = true
			if (this.validatenull(this.channelId)) {
				this.$message.error('数据有误!')
				return
			}
			let response = await getObj(this.channelId)
			if (this.validatenull(response) || this.validatenull(response.data)) {
				this.$message.error('请求数据有误!')
				return
			}
			let {
				customerSourceChannelId = '',
				customerSourceChannelType = '',
				wechatId = '',
				customerSource = '',
				settleType = '',
				settleAccounts = [],
				acquireTime = '',
				weworkGroupId = '',
				customerSourceType = '',
				channelFromWay = '',
				cusWay = 2,
				weworkGroupName = '',
			} = response.data.data || {}
			//优先把settleAccounts 全部转为private public
			//循环settleAccounts，
			//保存备份
			// settleAccounts.forEach((item) => {
			// 	let tempType = onGetSettleType(item.type)
			// 	item.type = tempType
			// 	if (tempType == SettleType.PRIVATE) {
			// 		this.settleAccountsSave[SettleType.PRIVATE].push(item)
			// 	} else {
			// 		this.settleAccountsSave[SettleType.PUBLIC].push(item)
			// 	}
			// })

			let decryptData = await decryptMessageByObject(response.data.data)
			//处理settleAccounts
			settleAccounts = await decryptMessageByArray(settleAccounts)

			this.settleInfoList = settleAccounts || []
			this.settleAccountsCopy = this.deepClone(settleAccounts) || []
			this.formData = decryptData
			this.formData.crmListStr = ''
			//反显客户列表
			let crmRes = await getCustomerList({channelId: this.channelId})
			console.log('crmRes', crmRes)
			let {code = 0, data = {}} = crmRes.data
			if (code == 0 && data && data.length > 0) {
				this.formData.crmListStr = data
					.map(
						({mobile = '', nickname = '', wechat = ''}) =>
							`客户名称：${nickname || '空'} 手机号：${mobile || '空'} ${wechat ? '微信号：' + wechat : ''}`,
					)
					.join('<br/>')
			}
			if (customerSourceType == 'CLUE') {
				//处理 customer 查询 crm 客户数据 根据 originChannelId（cusID）进行反查 反显
				let res = await searchCustomerClue({ids: [customerSource]})
				let {code = 0, data = {}} = res.data
				if (code == 0 && data && data.length > 0) {
					let {
						nickName = '',
						mobile = '',
						id = '',
						sourceIdLast = '',
						sourceIdText = '',
						customerSourceIdText = '',
						customerSourceChannelIdText = '',
					} = data[0]
					let label = `客户线索：${mobile || '空'}   线索首次客户来源：${customerSourceIdText || '空'}-${
						customerSourceChannelIdText || '空'
					}-${sourceIdText || '空'}`
					this.formData.clueLabel = label
				}
			}
			this.initClueFlag = true
			if (customerSourceType == 'HAND') {
				//初始化下客户来源类型
				if (customerSourceChannelType != 'customer') {
					this.formData.customerSourceChannelField = `${customerSourceChannelType || ''}${
						customerSourceChannelId || ''
					}`
					this.initCustomerSourceChannelFieldFlag = false
				} else {
					//处理 customer 查询 crm 客户数据 根据 originChannelId（cusID）进行反查 反显
					let res = await searchCrmCustomer({cusId: customerSourceChannelId})
					let {code = 0, data = {}} = res.data
					if (code == 0 && data.records && data.records.length > 0) {
						let dicData = this.findObject(this.optionData.column, 'customerSourceChannelField').dicData
						let cusObj = data.records[0]
						let {cusName = '', nickName = '', wechatNos = [], mainFollowIdName} = cusObj
						let label = `${cusName || '空'}-${nickName || '空'}-${
							wechatNos && wechatNos.length > 0 ? wechatNos.join('、') : '空'
						}-客户经理：${mainFollowIdName || '空'}`

						this.findObject(this.optionData.column, 'customerSourceChannelField').dicData = dicData.map((item) =>
							item.orginChannelType != 'customer'
								? item
								: {
										...item,
										originChanelLabel: `${item.originChanelLabel}-${label}`,
								  },
						)
						this.formData.customerSourceChannelField = 'customer'
						console.log('searchCrmCustomer', res)
					}
					this.initCustomerSourceChannelFieldFlag = true
				}
			}

			this.lastWechatId = wechatId
			if (!this.validatenull(wechatId) && this.validatenull(acquireTime)) {
				//获取首次获课时间
				await this.onGetFirstKeTime(wechatId)
			}

			// 修改：确保正确反显企微沟通群
			// 直接使用ID，组件会根据配置的props自动获取和显示名称
			this.formData.weworkGroupId = weworkGroupId

			// 加载企微沟通群数据
			if (weworkGroupId) {
				// 延迟加载企微沟通群数据，确保组件已经初始化
				// setTimeout(() => {
				this.loadWeworkGroupData()
				// }, 300)
			}

			//如果是老数据，没有结算人，则添加结算人
			if (this.validatenull(settleAccounts)) {
				this.settleInfoList = []
			}
			//如果状态是待审核状态则需要初始化默认参数
			if (this.formData.status == 4) {
				editFollowSort()
				this.initAddAll()
				this.onDealRewardSettlement(2)
			}
			//处理产品
			this.onDealInsureTypes()
			this.isTableLoading = false
		},
		//处理insureTypes
		onDealInsureTypes() {
			//如果是老数据 没有可用产品，则默认全选
			let {insureTypes = '', insureAuthority = ''} = this.formData
			this.isFirstInsureTypesNull = this.validatenull(insureTypes)
			if (this.isFirstInsureTypesNull || insureTypes === 'ALL_VISIBLE') {
				//处理可见
				this.formData.insureTypes = this.deepClone(this.insureTypesVisible)
			} else if (insureTypes === 'ALL') {
				this.formData.insureTypes = this.getInsureTypesData
			}
			if (this.validatenull(insureAuthority)) {
				this.formData.insureAuthority = 'ALL'
			}
		},
		async onDealRewardSettlement(type = 1) {
			let res = (await Promise.all([getSettlementRuleBasicList(), getSettlementRuleAwardList()])) || []
			if (res.length === 2) {
				let [basicData, awardData] = res
				let tempBasicData = basicData.data.data || []
				let tempAwardData = awardData.data.data || []
				this.findObject(this.optionData.column, 'ruleBasicId').dicData = tempBasicData
				this.findObject(this.optionData.column, 'ruleAwardIds').dicData = tempAwardData
				if (this.isAddType || type == 2) {
					//处理可用数据
					tempAwardData.forEach(({checked = 0, id = ''}) => {
						if (checked) {
							this.formData.ruleAwardIds.push(id)
						}
					})
					let tempData = tempBasicData.find(({checked = 0}) => checked === 1) || null
					if (tempData) {
						let {id = ''} = tempData
						this.formData.ruleBasicId = id
					}
				}
			}
		},
		//新增结算人信息
		initSettleData() {
			this.settleInfoList.push({
				userName: '',
				bankName: '',
				cardNo: '',
				channelId: 0,
				mobile: '',
				idNo: '',
				idType: '',
				taxFlag: '',
				emailFlag: '',
				email: '',
				sort: 0,
				type: this.formData.settleType,
				key: Date.now(),
			})
			this.autoSettleChangeRules()
		},
		onDel(index) {
			//如果开启自动结算，结算数据不能为空
			if (this.formData.autoSettle == '1' && this.settleInfoList.length == 1) {
				this.$alert('开启自动结算时，结算人信息不能为空！', '提示', {
					confirmButtonText: '确定',
				})
				return
			}
			if (!this.isSettlePrivate) {
				//如果为对公支付，则直接删除
				this.settleInfoList = []
				return
			}
			// if (this.settleInfoList.length <= 1) {
			// 	this.$message.error('结算人信息不能为空')
			// 	return
			// }
			this.settleInfoList.splice(index, 1)
		},
		onCommitHint() {
			this.$refs.form_ts.validate((valid, done) => {
				done()
				if (valid) {
					//如果账户状态是体验账号
					if (this.formData.accountType == 2) {
						let method = this.isAddType ? 'post' : 'put'
						let req = {
							accountType: this.formData.accountType,
							name: this.formData.name,
							loginMobile: this.formData.loginMobile,
							contactPerson: this.formData.contactPerson,
							contactPersonMobile: this.formData.contactPersonMobile,
							contactId: this.formData.contactId,
						}
						if (this.formData.id) {
							req.id = this.formData.id
						}
						this.formData.insureTypes = ''
						getPutObj(method, req)
							.then(() => {
								this.$message.success('操作成功!')
							})
							.finally(() => {
								setTimeout(() => {
									this.isSubLoading = false
									this.isTableLoading = false
								}, 500)
							})

						return
					}
					let tempData = 0
					console.log('this.$refs.form_ts_person', this.$refs)
					//双规账户不需要结算人
					if (
						this.$refs.form_ts_person &&
						this.formData.settleMethod != 'DUAL' &&
						Array.isArray(this.$refs.form_ts_person) &&
						this.$refs.form_ts_person.length > 0
					) {
						console.log('this.$refs.form_ts_person', this.$refs.form_ts_person)

						for (let formTsPerson of this.$refs.form_ts_person) {
							formTsPerson.validate((valid1, done1) => {
								done1()
								if (valid1) {
									tempData++
									if (tempData === this.$refs.form_ts_person.length) {
										this.$confirm('请仔细检查渠道信息，是否确认提交？', '提交', {
											cancelButtonText: '再看看',
											confirmButtonText: '确定提交',
										})
											.then(() => {
												this.onCommit()
											})
											.catch(() => {})
									}
								} else {
									this.$message.error('请完善渠道内容')
								}
							})
						}
					} else {
						this.onCommit()
					}
				} else {
					this.$message.error('请完善渠道内容')
				}
			})
		},
		onCommit() {
			console.log('oncmit')
			//确认信息
			//首次获客时间<=账号创建时间
			let {
				createdAt = '',
				acquireTime = '',
				settleProtocols = '',
				loginMobile = '',
				settleType = '',
				autoSettle,
			} = this.formData
			let acTime = new Date(acquireTime).getTime()
			if ((createdAt !== '' && new Date(createdAt).getTime() < acTime) || (createdAt === '' && Date.now() < acTime)) {
				this.$message.error('首次获客时间不能大于账号创建时间！')
				return
			}
			let formDataReq = this.deepClone(this.formData)
			//如果是待审核状态 提交的时候改为正常状态
			if (formDataReq.status == 4) {
				formDataReq.status = 1
			}
			//如果是自动结算，没有结算信息，则不允许提交
			if (autoSettle === '1' && this.settleInfoList.length <= 0) {
				this.$message.error('开启自动结算时，结算信息不能为空！')
				return
			}
			// 主渠道使用手机号作为登录名
			this.isSubLoading = true
			formDataReq.loginName = loginMobile
			formDataReq.password = ''
			//如果是对公支付，则需要处理上传文件
			if (this.isSettlePrivate) {
				formDataReq.settleProtocols = ''
			} else {
				if (settleProtocols && settleProtocols.includes(',,')) {
					//存在空数据，需要处理
					let tempProtocols = settleProtocols.split(',').filter((itemPro = '') => itemPro !== '') || []
					formDataReq.settleProtocols = tempProtocols.length > 0 ? tempProtocols.join(',') : ''
				}
				//对公只有月结
				formDataReq.settlePeriod = 'MONTH'
			}
			//赋值
			let tempSettleAccounts = this.deepClone(this.settleInfoList)
			//合并之前的旧数据
			let tempSettleData = this.getCopySettleData()
			if (!this.validatenull(tempSettleData)) {
				tempSettleAccounts = tempSettleAccounts.concat(tempSettleData)
			}
			//处理排序
			tempSettleAccounts.forEach((itemData, index) => {
				let {type = '', idNo = '', cardBackUrl = [], cardFrontUrl = []} = itemData
				itemData.channelId = this.channelId
				itemData.sort = index
				if (isSettlePrivateFn(type)) {
					//对私
					itemData.idType = '身份证'
				} else {
					//删除身份证
					if (idNo) {
						delete itemData.idNo
					}
				}
				//处理身份证图片
				if (this.validatenull(cardBackUrl)) {
					delete itemData.cardBackUrl
				}
				if (this.validatenull(cardFrontUrl)) {
					delete itemData.cardFrontUrl
				}
				itemData.type = onGetSettleType(type)
			})

			let tempInsureTypes = this.findObject(this.optionData.column, 'insureTypes')
			//处理 如果formDataReq.insureTypes 为集合则转为string
			let tempTypes = formDataReq.insureTypes
			if (!this.validatenull(tempTypes) && typeof tempTypes === 'object') {
				tempTypes = tempTypes.join(',')
			}
			// let {businessAreas = []} = formDataReq
			// formDataReq.businessAreas = businessAreas.join(',')
			if (!this.validatenull(tempInsureTypes.dicData) && !this.validatenull(tempTypes)) {
				if (tempInsureTypes.dicData.length === tempTypes.split(',').length) {
					//all
					formDataReq.insureTypes = 'ALL'
				} else {
					//所选产品中，无不可见产品，并且和 可见产品长度一样，则ALL_VISIBLE
					let tempIndex = tempTypes.split(',').findIndex((itemData) => {
						return this.insureTypesInvisible.includes(parseInt(itemData))
					})
					if (tempIndex === -1 && tempTypes.split(',').length === this.insureTypesVisible.length) {
						formDataReq.insureTypes = 'ALL_VISIBLE'
					} else {
						formDataReq.insureTypes = tempTypes
					}
				}
			}
			// 由于select组件配置了multiple和props，可能会返回复杂格式
			// 如果是数组格式的字符串，需要提取出所有ID
			if (formDataReq.weworkGroupId) {
				// 处理可能的多选情况
				if (Array.isArray(formDataReq.weworkGroupId)) {
					// 如果是数组，提取所有数字ID
					const ids = []
					formDataReq.weworkGroupId.forEach((item) => {
						// 检查是否为数字ID
						if (/^\d+$/.test(item)) {
							ids.push(item)
						} else if (typeof item === 'string' && item.includes(',')) {
							// 处理"名称,ID"格式
							const parts = item.split(',')
							if (parts.length > 1 && /^\d+$/.test(parts[1])) {
								ids.push(parts[1])
							}
						}
					})
					formDataReq.weworkGroupId = ids.join(',')
				} else if (typeof formDataReq.weworkGroupId === 'string') {
					// 如果是字符串，可能是单个ID或逗号分隔的多个ID
					const parts = formDataReq.weworkGroupId.split(',')
					const ids = []

					for (let i = 0; i < parts.length; i++) {
						const part = parts[i].trim()
						// 检查是否为数字ID
						if (/^\d+$/.test(part)) {
							ids.push(part)
						} else if (i + 1 < parts.length && /^\d+$/.test(parts[i + 1].trim())) {
							// 如果当前部分不是数字，但下一个部分是数字，说明是"名称,ID"格式
							ids.push(parts[i + 1].trim())
							i++ // 跳过下一个部分，因为已经处理了
						}
					}

					formDataReq.weworkGroupId = ids.join(',')
				}
			}

			if (formDataReq.settleMethod == 'DUAL') {
				tempSettleAccounts = undefined
			}
			// else {
			// 	let spliceIndex = []

			// 	//判断结算是否关闭 如果关闭的话，相关结算信息不是必填 但是如果填写了某一项目 则需要全部填写
			// 	if (this.formData.autoSettle != 1) {
			// 		for (let i = 0; i < tempSettleAccounts.length; i++) {
			// 			let flag = false
			// 			let {
			// 				type: tempItemType,
			// 				userName = '',
			// 				mobile = '',
			// 				idNo = '',
			// 				cardNo = '',
			// 				bankName = '',
			// 				email = '',
			// 				emailFlag = '',
			// 			} = tempSettleAccounts[i] || {}
			// 			//判断里面是否有填写了信息
			// 			if (userName || mobile || idNo || cardNo || bankName || email || emailFlag) {
			// 				flag = true
			// 			}
			// 			if (flag) {
			// 				//如果已经填写了信息 则判断是否填写全部信息
			// 				let tempType = onGetSettleType(tempItemType)
			// 				if (
			// 					(tempType == SettleType.PRIVATE && userName && mobile && idNo && cardNo && bankName) ||
			// 					(tempType == SettleType.PUBLIC &&
			// 						userName &&
			// 						cardNo &&
			// 						bankName &&
			// 						((emailFlag == '1' && email) || emailFlag == '0'))
			// 				) {
			// 				} else {
			// 					console.log('flag-2', tempSettleAccounts[i])
			// 					this.isSubLoading = false
			// 					this.isTableLoading = false
			// 					this.$message.error('结算信息已填写部分，请填写完整！')
			// 					return
			// 				}
			// 			} else {
			// 				spliceIndex.push(i)
			// 			}
			// 		}
			// 	}
			// 	//删除这一项
			// 	tempSettleAccounts = tempSettleAccounts.filter((item2, index) => spliceIndex.findIndex((o) => o == index) == -1)
			// 	if (this.validatenull(tempSettleAccounts)) {
			// 		tempSettleAccounts = undefined
			// 	}
			// }

			console.log('flag-3', formDataReq)
			let method = this.isAddType ? 'post' : 'put'
			this.isTableLoading = true
			formDataReq.name = formDataReq.name.replaceAll('(', '（').replaceAll(')', '）').replaceAll(',', '，')
			//赋值结算信息
			formDataReq.settleAccounts = tempSettleAccounts
			getPutObj(method, formDataReq)
				.then(() => {
					this.$message.success('操作成功!')
					if (!this.isSettlePrivate) {
						this.formData.settlePeriod = 'MONTH'
					}
					this.settleAccountsCopy = this.deepClone(tempSettleAccounts)
				})
				.finally(() => {
					setTimeout(() => {
						this.isSubLoading = false
						this.isTableLoading = false
					}, 500)
				})
		},
		//请求获客时间
		async onGetFirstKeTime(wechatId) {
			let tempHuoke = await getFirstHuokeTime(wechatId)
			let tempDate = ''
			if (tempHuoke && tempHuoke.data.data) {
				tempDate = tempHuoke.data.data
			}
			this.formData.acquireTime = tempDate
		},
		//微信号失去焦点请求数据
		onWechatBlur({column, value}) {
			if (!this.isAddType && !this.validatenull(this.formData.acquireTime)) {
				return
			}
			if (value && this.lastWechatId !== value) {
				//获取获客时间
				this.onGetFirstKeTime(value)
				this.lastWechatId = value
			}
		},
		//获取当前备份中的结算信息
		getCopySettleData() {
			if (!this.validatenull(this.settleAccountsCopy)) {
				//解构
				let {settleType = ''} = this.formData
				let tempSettleData = this.settleAccountsCopy.filter(({type}) => {
					//如果是代理人，则只加对公数据
					if (this.isSettleAgent) {
						return !isSettlePrivateFn(type)
					}
					return !isSettleTypeSame(settleType, type)
				})
				return tempSettleData
			}
			return []
		},
		/**
		 * 设置结算信息
		 */
		setSettleAccountData(newVal) {
			//获取缓存
			this.settleInfoList = []
			setTimeout(async () => {
				let settleAccountsSaveTemp = this.settleAccountsSave[newVal]
				//如果缓存存在，则直接用
				if (!this.validatenull(settleAccountsSaveTemp)) {
					this.settleInfoList = settleAccountsSaveTemp
				} else {
					//等于空，则先去从数据获取
					this.settleInfoList = await this.filterSettleInfo(this.settleAccountsCopy, newVal)
				}
			}, 200)
			// this.settleInfoList = []
			// setTimeout(() => {
			// 	if (!this.validatenull(settleAccountsSaveTemp)) {
			// 		this.settleInfoList = settleAccountsSaveTemp
			// 	} else {
			// 		//等于空，则先去从数据获取
			// 		this.settleInfoList = this.settleAccountsCopy.filter(({type}) => {
			// 			return isSettleTypeSame(newVal, type)
			// 		})
			// 	}
			// 	//替换
			// 	this.settleInfoList.forEach((itemData) => {
			// 		if (this.validatenull(itemData.type)) {
			// 			itemData.type = newVal
			// 		}
			// 	})
			// }, 200)
		},

		onDealItem(showDataList = []) {
			if (showDataList.length > 0) {
				for (let i = 0; i < showDataList.length; i++) {
					let {prop = '', display = '', row = '', label = '', span = '', rules, disabled = false} = showDataList[i]
					let tempObj = this.findObject(this.optionData.column, prop) || {}
					if (typeof display === 'boolean') {
						tempObj.display = display
					}
					if (typeof row === 'boolean') {
						tempObj.row = row
					}
					if (label) {
						tempObj.label = label
					}
					if (span) {
						tempObj.span = span
					}
					if (rules) {
						tempObj.rules = rules
					}
					tempObj.disabled = disabled
				}
			}
		},
		// 加载企微沟通群数据
		loadWeworkGroupData() {
			console.log('开始加载企微沟通群数据')
			const weworkGroupId = this.formData.weworkGroupId

			if (!weworkGroupId) {
				console.log('没有企微沟通群ID，跳过加载')
				return
			}

			console.log('企微沟通群ID:', weworkGroupId)

			// 使用统一的API函数查询企微沟通群数据
			searchWeworkGroup({ids: weworkGroupId})
				.then((res) => {
					console.log('企微沟通群数据查询结果:', res)
					if (res.data.code == 0 && res.data.data) {
						const groupData = res.data.data

						// 更新组件配置中的dicData
						const weworkGroupColumn = this.findObject(this.optionData.column, 'weworkGroupId')
						console.log('weworkGroupColumn', groupData, weworkGroupColumn)
						if (weworkGroupColumn) {
							console.log('更新企微沟通群组件dicData:', groupData)
							weworkGroupColumn.dicData = groupData

							// 确保DIC数据在表单中可用
							if (this.$refs.form_ts && this.$refs.form_ts.DIC) {
								this.$refs.form_ts.DIC.weworkGroupId = groupData
							}

							// 重新初始化表单
							if (this.$refs.form_ts) {
								this.$refs.form_ts.init()
							}
						}
					} else {
						console.error('企微沟通群数据查询失败或返回数据为空')
					}
				})
				.catch((error) => {
					console.error('企微沟通群数据查询出错:', error)
				})
		},
		handleUploadError(error = '', column) {
			console.log('上传失败', error, column)
			//如果 error 包含 size，则提示
			if (error.includes('size')) {
				this.$message.error('文件大小超过限制')
			}
			//如果 error 包含 type，则提示
			if (error.includes('type')) {
				this.$message.error('文件类型不支持')
			}
		},
		/**
		 * 如果是代理人佣金，但是没有获取到数据，则代理人佣金不能选择，并且清除结算数据
		 */
		onHandleAgentSettle() {
			let tempSettleType = this.findObject(this.optionData.column, 'settleType')
			if (tempSettleType) {
				tempSettleType.dicData.forEach((item) => {
					//	value: 'AGENT', 代理人佣金
					if (item.value === SettleType.AGENT) {
						//设置为不可点击
						this.$set(item, 'disabled', true)
						//另外清空其他数据
						//结算方式为第三方清分
						this.formData.settleType = SettleType.PRIVATE
					}
				})
			}
		},

		/**
		 * 禁止编辑
		 */
		onDisableEdit(disabled) {
			//表单
			this.optionData.column.forEach((item) => {
				item.disabled = disabled
			})
			//结算
			this.settleInfoOption.column.forEach((item) => {
				item.disabled = disabled
			})
			this.isView = disabled
		},
	},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .avue-form__menu {
	height: 0 !important;
	margin-bottom: 0 !important;
	padding: 0 !important;
}

::v-deep .el-col {
	margin-bottom: 0 !important;
}

.divide {
	background-color: #dcdfe6;
	height: 1px;
}

::v-deep .el-input.is-disabled .el-input__inner {
	color: #8f8f8f;
}

::v-deep .el-range-editor.is-disabled input {
	color: #8f8f8f;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
	color: #8f8f8f;
}

::v-deep .avue-upload--list .el-upload {
	border: none !important;
}
</style>
